import { infiniteQueryOptions } from "@tanstack/react-query";

import { queries } from "@/api/graphql/constants.ts";
import {
  getNotificationsByAccount,
  getNotificationsByUser,
} from "@/api/graphql/notifications/api.ts";
import {
  GetNotificationsByAccount,
  GetNotificationsByUser,
} from "@/api/graphql/notifications/types.ts";
import { NotificationsMsSearchNotificationsRequestSortField } from "@/api/graphql/types/graphql.ts";
import { getNextPage } from "@/helpers/api/getNextPageParam/helper.ts";

const createNotificationsQueryOptions = (
  queryKey: string,
  request: Pick<GetNotificationsByUser, "pageSize"> & {
    userId?: string;
    accountId?: string;
  },
  queryFn: typeof getNotificationsByUser | typeof getNotificationsByAccount,
) =>
  infiniteQueryOptions({
    queryKey: [queryKey, request.userId ?? request.accountId, request.pageSize],
    initialPageParam: 1,
    queryFn: ({ pageParam = 1 }) =>
      queryFn({
        filters: request.userId
          ? { userId: request.userId }
          : { accountId: request.accountId },
        paging: {
          page: pageParam,
          size: request.pageSize,
        },
        sorts: {
          field: NotificationsMsSearchNotificationsRequestSortField.CreatedTs,
          ascending: false,
        },
      }),
    getNextPageParam: (lastPage) => getNextPage(lastPage.pagination),
    enabled: Boolean(request.userId ?? request.accountId),
  });

export const createGetNotificationsByUserQueryOptions = (
  request: GetNotificationsByUser,
  queryFn: typeof getNotificationsByUser = getNotificationsByUser,
) =>
  createNotificationsQueryOptions(
    queries.GET_NOTIFICATIONS_BY_USER,
    request,
    queryFn,
  );

export const createGetNotificationsByAccountQueryOptions = (
  request: GetNotificationsByAccount,
  queryFn: typeof getNotificationsByAccount = getNotificationsByAccount,
) =>
  createNotificationsQueryOptions(
    queries.GET_NOTIFICATIONS_BY_ACCOUNT,
    request,
    queryFn,
  );
